<template>
  <PagePasswordForgotten/>
</template>

<script>
import AppRouteMixin from '~/mixins/AppRouteMixin'
import LoggedOutUserRestrictedRouteMixin from '~/mixins/LoggedOutUserRestrictedRouteMixin'
import PagePasswordForgotten from '@theme/components/user/PagePasswordForgotten'

const PAGE = {
  name: 'RoutePasswordForgotten',
  nuxtI18n: {
    paths: {
      cs: '/zapomenute-heslo',
      de: '/passwort-vergessen',
      en: '/forgotten-password',
      sk: '/zabudnute-heslo',
    },
  },
  middleware({ store }) {
    store.commit('locale/SET_ALTERNATIVE_PATHS', PAGE.nuxtI18n.paths)
  },
  components: {
    PagePasswordForgotten,
  },
  mixins: [AppRouteMixin, LoggedOutUserRestrictedRouteMixin],
  async asyncData({ store }) {
    store.commit('locale/SET_CANONICALS')
  },
}
export default PAGE
</script>
